// extracted by mini-css-extract-plugin
module.exports = {"loader":"hb","smallLoader":"ib","loading-keyframes":"jb","pageLoader":"kb","centered":"lb","whitespacePlaceholder":"mb","buttonSpinner":"nb","fade-in":"ob","rotate":"pb"};